// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6TajL","label":"styles_label__3I607"};